const SUBSCRIPTION = {
  GET_SUBSCRIPTION: 'GET_SUBSCRIPTION',
  GET_SUBSCRIPTION_SUCCESS: 'GET_SUBSCRIPTION_SUCCESS',
  GET_SUBSCRIPTION_FAILURE: 'GET_SUBSCRIPTION_FAILURE',
  GET_SUBSCRIPTION_INFO: 'GET_SUBSCRIPTION_INFO',
  GET_SUBSCRIPTION_INFO_SUCCESS: 'GET_SUBSCRIPTION_INFO_SUCCESS',
  SET_EXPIRED_STATUS: 'SET_EXPIRED_STATUS',
  SET_USER_DETAILS: 'SET_USER_DETAILS',
  FORBIDDEN_ACCESS: 'FORBIDDEN_ACCESS',
  GET_SUBSCRIPTION_VIEWED: 'GET_SUBSCRIPTION_VIEWED',
  NO_ACTIVE_SUBS: 'NO_ACTIVE_SUBS'
}

export { SUBSCRIPTION }